
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.334 8.333 8.334S18.334 14.6 18.334 10 14.6 1.667 10 1.667zM5.892 15.234c.358-.75 2.542-1.484 4.108-1.484 1.567 0 3.759.734 4.109 1.484A6.578 6.578 0 0110 16.667a6.577 6.577 0 01-4.108-1.433zM10 12.084c1.217 0 4.109.491 5.3 1.941A6.625 6.625 0 0016.667 10 6.676 6.676 0 0010 3.334 6.676 6.676 0 003.334 10c0 1.517.516 2.909 1.366 4.025 1.192-1.45 4.084-1.941 5.3-1.941zM10 5a2.91 2.91 0 00-2.916 2.917A2.91 2.91 0 0010 10.834a2.91 2.91 0 002.917-2.917A2.91 2.91 0 0010 5zM8.75 7.917c0 .692.559 1.25 1.25 1.25.692 0 1.25-.558 1.25-1.25s-.558-1.25-1.25-1.25c-.691 0-1.25.558-1.25 1.25z","fill":"#1D3C6F"}})])
          )
        }
      }
    